import React from "react";
import { useNavigate } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import notFoundImg from "../../Assets/Images/NotFound404.png";
import notFoundAnimatedImg from "../../Assets/Images/NotFound404.webp";
import notFoundDarkImg from "../../Assets/Images/NotFound404Dark.png";
import notFoundDarkAnimatedImg from "../../Assets/Images/NotFound404Dark.webp";
import { APPRoutes } from "../../Utils/Route";

const ART = {
    light: { still: notFoundImg, animated: notFoundAnimatedImg },
    dark: { still: notFoundDarkImg, animated: notFoundDarkAnimatedImg },
};

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <ErrorPage
            code="404"
            title="Page Not Found"
            message="The page you are looking for doesn’t exist or may have been moved. Please check the address or go back to home."
            art={ART}
            actions={[
                { label: "Go Back", onClick: () => navigate(-1) },
                { label: "Home", onClick: () => navigate(APPRoutes.LOGIN), variant: "outline" },
            ]}
        />
    );
};

export default NotFound;
